import service from '@/utils/server';

const modName='/report/reportDelay/';
//查询方法(延迟原因总汇总)
export const pageInfo = data => {
  return service({
    url: modName + 'delayInfo',
    method: 'post',
    data
  });
};

export const delayCarrierInfo = data => {
  return service({
    url: modName + 'delayCarrierInfo',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/report/delay/api/index.js